const ReportIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1011_37457)">
        <path
          d="M9.6502 0.449951C9.3502 0.449951 9.0752 0.699951 9.0752 1.02495V6.02495C9.0752 6.32495 9.3252 6.59995 9.6502 6.59995H15.0002C15.1502 6.59995 15.3002 6.52495 15.4002 6.42495C15.5002 6.29995 15.5502 6.14995 15.5502 5.99995C15.3502 2.87495 12.7502 0.449951 9.6502 0.449951ZM10.2002 5.42495V1.59995C12.2752 1.84995 13.9502 3.39995 14.3502 5.44995H10.2002V5.42495Z"
          fill="#9CA3AF"
        />
        <path
          d="M13.6752 7.72495H8.1002V2.34995C8.1002 2.04995 7.8502 1.79995 7.5502 1.79995C7.4752 1.79995 7.4002 1.79995 7.3252 1.79995C3.5252 1.77495 0.450195 4.87495 0.450195 8.67495C0.450195 12.475 3.5502 15.575 7.3502 15.575C11.1502 15.575 14.2502 12.475 14.2502 8.67495C14.2502 8.52495 14.2502 8.37495 14.2252 8.24995C14.2252 7.94995 13.9752 7.72495 13.6752 7.72495ZM7.3502 14.45C4.1502 14.45 1.5752 11.875 1.5752 8.67495C1.5752 5.62495 3.9752 3.09995 7.0002 2.92495V8.27495C7.0002 8.57495 7.2502 8.84996 7.5752 8.84996H13.1502C13.0502 11.95 10.4752 14.45 7.3502 14.45Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1011_37457">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReportIcon;
